// extracted by css-extract-rspack-plugin
export default {"messageAccent":"Xas0M"};